// import { isBusinessError } from '@/queries/api-client';
import { TimeoutError } from 'ky';

export enum ErrorType {
  NETWORK = 'NETWORK',
  SERVER_API = 'API',
  CHUNK_LOAD = 'CHUNK_LOAD',
  RUNTIME = 'RUNTIME',
}

// 错误类型判断
export function getErrorType(error: unknown): ErrorType {
  if (error instanceof TimeoutError) {
    return ErrorType.NETWORK;
  }

  // if (isBusinessError(error)) {
  //   return ErrorType.SERVER_API;
  // }

  if (isChunkLoadError(error)) {
    return ErrorType.CHUNK_LOAD;
  }

  return ErrorType.RUNTIME;
}

export function isChunkLoadError(error: unknown): error is Error {
  return (
    typeof error === 'object' &&
    error !== null &&
    'name' in error &&
    (error as { name: string }).name === 'ChunkLoadError'
  );
}
